import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../../common/html/element'
import { Panel } from '../../../../common/panel'
import { Table } from '../../../../common/table'
import { RULES_TYPE } from '../../../common/constant'
import { selectProfileById } from '../../store/slice'
import { FINANCIAL_RULES_COL } from '../constant'
import classes from '../index.module.scss'
import { NameScore } from '../scoreRules/NameScore'
import { selectDataTable, selectIdsTable } from '../store/slice'
import { ConditionCell } from './ConditionCell'
import { EmailCell } from './EmailCell'
import { SwitchCell } from './SwitchCell'

export const FinancialRules = ({ isCreate = false }) => {
  const [search] = useSearchParams()

  const id = search.get('profileId')
  const ids = useSelector(selectIdsTable([RULES_TYPE.FINANCIAL_RULES]))
  const data = useSelector(selectDataTable(ids[0]))
  const isDefaultProfile = useSelector(
    selectProfileById(+id, 'isDefaultProfile'),
  )

  const getSchema = () => {
    return Object.keys(FINANCIAL_RULES_COL).map((key) => {
      const title = `alertSetting.${key}`
      const colId = FINANCIAL_RULES_COL[key]
      const thStyle = {
        justifyContent: [FINANCIAL_RULES_COL.SEND_EMAILS].includes(colId)
          ? 'center'
          : '',
      }
      const tdStyle = {
        width:
          colId === FINANCIAL_RULES_COL.SWITCH
            ? 40
            : colId === FINANCIAL_RULES_COL.SEND_EMAILS
            ? '25%'
            : colId === FINANCIAL_RULES_COL.FINANCIAL_INDICATOR
            ? '33%'
            : '',
        position: 'relative',
      }

      return {
        colId,
        title,
        isI18n: true,
        thStyle,
        tdStyle,
        renderTh: (title) => {
          switch (colId) {
            case FINANCIAL_RULES_COL.SWITCH:
              return ''
            default:
              return title
          }
        },
        render: (data, { rowId }) => {
          switch (colId) {
            case FINANCIAL_RULES_COL.SWITCH:
              return <SwitchCell rowId={rowId} isCreate={isCreate} />
            case FINANCIAL_RULES_COL.FINANCIAL_INDICATOR:
              return <NameScore rowId={rowId} />
            case FINANCIAL_RULES_COL.CONDITION:
              return (
                <ConditionCell
                  rowId={rowId}
                  isDefaultProfile={isCreate ? false : !!isDefaultProfile}
                />
              )
            case FINANCIAL_RULES_COL.SEND_EMAILS:
              return <EmailCell rowId={rowId} />
            default:
              return ''
          }
        },
      }
    })
  }

  return (
    <Panel label={data?.groupName}>
      <Element style={{ backgroundColor: '#FFFFFF' }}>
        <Element
          className={classes.note}
          style={{ color: '#3A414B', borderBottomColor: '#B5CEF8' }}
        >
          <Translate value="alertSetting.FINANCIAL_RULES_NOTE" />
        </Element>
        <Table ids={ids} schema={getSchema()} autoHeightMax={600} />
      </Element>
    </Panel>
  )
}
